import { type LegacyApiError, useApi } from '@omnipresentgroup/api';
import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import type { GetTimesheetResponse } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

type UseGetTimesheetParameters =
  | {
      timesheetId: string;
      employeeId?: never;
      weekDate?: never;
      enabled?: boolean;
    }
  | {
      employeeId: string;
      weekDate: string;
      timesheetId?: never;
      enabled?: boolean;
    };

export const useGetTimesheet = ({
  timesheetId,
  employeeId,
  weekDate,
  enabled,
}: UseGetTimesheetParameters) => {
  const { GET } = useApi();

  return useQuery<GetTimesheetResponse, LegacyApiError>({
    queryKey: [API_PATH, timesheetId, employeeId, weekDate],
    enabled: enabled || !!timesheetId || (!!employeeId && !!weekDate),
    queryFn: () =>
      GET<GetTimesheetResponse>(
        `${API_BASE}/${API_PATH}/${
          timesheetId || `employees/${employeeId}/week/${weekDate}`
        }`,
      ),
    throwOnError: (error) => error.status !== HTTPStatusCodes.NOT_FOUND,
  });
};
